import $ from 'jquery'
import { createAlert } from 'dom/window'
// import _ from 'lodash';
import { axiosInstance as axios, handleAxiosErrors } from '_utils'
import { segmentTrackOrderCompleted } from '../utils/segment/track'
import config from '../store/_config'
import {
  convertAvailableDeliveryDatesToReact,
  buildCheckoutData,
  convertCartToReact,
  convertCheckoutDetailsToReact,
  convertAvailableDeliveryAddressesToReact,
  buildNewAddressData,
  createDummyAvailableDeliveryDates,
} from '../selectors/converterSelectors'
import { axiosRequestDeliveryAddresses, getAddressComponent } from './addressActions'
import { setUserCredentials } from '../actions/userActions'
import { getCurrentLoyaltyPointsCheckout, getCardId, getPaymentGateway } from '../selectors/defaultSelectors'
import { LS } from '../store/localStorage'
import {
  segmentTrackCheckoutStarted,
  segmentTrackCheckoutStepViewed,
  segmentTrackPaymentInfoEntered,
  segmentTrackCheckoutStepCompleted,
} from '../utils/segment/ecommerce'
import { resetActiveCustomer, updateActiveCustomerName, updateActive3PLCustomerName } from './supplierActions'
import moment from 'moment'

// TODO: dynamic url (fetchURL)
//       - requestCart
//       - checkout
export const setCheckoutGlobalConfig = (value) => {
  return {
    type: 'SET_CHECKOUT_GLOBAL_CONFIG',
    value,
  }
}

export const setCheckoutShippingMethod = (value) => {
  return {
    type: 'SET_CHECKOUT_SHIPPING_METHOD',
    value: value,
  }
}

export const toggleCheckoutLoading = (key, value) => {
  return {
    type: 'TOGGLE_CHECKOUT_LOADING',
    key: key,
    value: value,
  }
}
export const handleFieldUpdate = (key, value) => {
  return {
    type: 'UPDATE_CHECKOUT_DETAILS',
    key: key,
    value: value,
  }
}
export const handleCheckoutCartFieldUpdate = (key, value) => {
  return {
    type: 'UPDATE_CHECKOUT_CART_DETAILS',
    key: key,
    value: value,
  }
}
export const handleNewAddressFieldUpdate = (key, value) => {
  return {
    type: 'UPDATE_CHECKOUT_ADDRESS_FORM',
    key: key,
    value: value,
  }
}
export const replaceCheckoutCartDetails = (details) => {
  return {
    type: 'REPLACE_CHECKOUT_CART_DETAILS',
    details: details,
  }
}
export const updateSelectedAddress = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_SELECTED_DELIVERY_ADDRESS',
      value: value,
    })

    // Request delivery dates as well
    dispatch(requestDeliveryDates())
  }
}
export const updateSelectedDeliveryDate = (key, value) => {
  return (dispatch, getState) => {
    dispatch(handleFieldUpdate(key, value))
    dispatch(reUpdateDeliveryDate(value))
    dispatch(reCalculateCheckoutSurcharge(value))

    dispatch(handleFieldUpdate('selectedDeliveryDateToBeConfirmed', ''))
    $('#confirm-delivery-date-modal').modal('hide')
  }
}

//Created updateSelectedDeliveryDateCopy due to extra updateCart calls
export const updateSelectedDeliveryDateCopy = (key, value) => {
  return (dispatch, getState) => {
    dispatch(handleFieldUpdate(key, value))
    dispatch(reCalculateCheckoutSurcharge(value))

    dispatch(handleFieldUpdate('selectedDeliveryDateToBeConfirmed', ''))
    $('#confirm-delivery-date-modal').modal('hide')
  }
}

export const updateThreePlCheckoutShippingMethodDate = (key, value) => {
  return (dispatch, getState) => {
    dispatch(handleFieldUpdate(key, value))
    dispatch(reUpdateShippingMethod(value))
  }
}

export const updateThreePlCheckoutShippingMethodPickup = (key, value) => {
  return (dispatch, getState) => {
    dispatch(handleFieldUpdate(key, value))
    dispatch(reUpdateShippingMethodPickup(value))
  }
}

export const updateSelectedDeliveryDateToBeConfirmed = (value) => {
  return (dispatch, getState) => {
    dispatch(handleFieldUpdate('selectedDeliveryDateToBeConfirmed', value))
    // dispatch(reUpdateDeliveryDate(value))
    $('#confirm-delivery-date-modal').modal('show')
  }
}
export const updateSelectedCreditCard = (value) => {
  return (dispatch, getState) => {
    dispatch(handleFieldUpdate('selectedCreditCard', value))
  }
}
export const updateCart = (cart) => {
  return {
    type: 'UPDATE_CHECKOUT_CART',
    cart: cart,
  }
}
export const updateDeliveryAddresses = (value) => {
  return {
    type: 'UPDATE_AVAILABLE_DELIVERY_ADDRESSES',
    value: value,
  }
}
export const updateDeliveryDates = (value) => {
  return {
    type: 'UPDATE_AVAILABLE_DELIVERY_DATES',
    value: value,
  }
}
export const requestCart = () => {
  return async (dispatch, getState) => {
    const state = getState()
    const customerID = typeof state.user.user != 'undefined' ? state.user.user : 0

    const readGlobalConfigResponse = await axiosRequestCheckoutPaymentMethods()
    const globalConfig = readGlobalConfigResponse?.data?.data?.readGlobalConfig
    dispatch(setCheckoutGlobalConfig(globalConfig))
    const readShippingResponse = await axiosRequestCheckoutShippingMethods()
    const shippingResponse = readShippingResponse?.data?.data?.readAvailableShippingMethods
    const shippingMethod = convertShippingMethod(shippingResponse)
    dispatch(setCheckoutShippingMethod(shippingMethod))

    if (customerID) {
      dispatch(toggleCheckoutLoading('cart', true))

      return axiosRequestCart(customerID)
        .then((response) => {
          const cart = response.data.data.readOneCart

          dispatch(toggleCheckoutLoading('cart', false))

          // Cart
          const list = convertCartToReact(cart, state.user)
          dispatch(updateCart(list))

          dispatch(
            setUserCredentials({
              calculatedCurrentLoyaltyPoints: getCurrentLoyaltyPointsCheckout(list),
            })
          )

          // Checkout Detail
          const details = convertCheckoutDetailsToReact(cart)

          //Store applied coupons
          if (details?.appliedDiscountCoupons?.[0]?.InternalItemID) {
            dispatch(handleFieldUpdate('couponCode', details?.appliedDiscountCoupons?.[0]?.InternalItemID))
            dispatch(handleFieldUpdate('isCouponApplied', true))
            dispatch(handleFieldUpdate('isCouponValid', true))
          }

          details.memberid = customerID
          dispatch(replaceCheckoutCartDetails(details))

          const cartId = cart?.ID

          segmentTrackCheckoutStarted(list, cartId, details)

          let updatedState = getState()
          const selectedPaymentMethod = updatedState.checkout.details.selectedPaymentMethod

          segmentTrackCheckoutStepViewed(cartId, selectedPaymentMethod, null)
        })
        .catch((error) => {
          dispatch(toggleCheckoutLoading('cart', false))
        })
    }
  }
}

export const convertShippingMethod = (list, user) => {
  let newList = []

  list.map((item, index) => {
    //const { node } = item;
    const node = item
    const { ID, Title, HandlingFee, Total, EstimatedDelivery, IsTaxable, AllowNotes, activeShipping } = node

    let data = {
      id: ID,
      title: Title || '',
      handlingFee: HandlingFee || '',
      activeShipping: true,
    }

    newList.push(data)
  })

  return newList
}

export const axiosRequestCheckoutPaymentMethods = () => {
  let { url, query } = config.checkout.paymentMethod

  return axios
    .get(url, {
      params: {
        query,
      },
    })
    .catch((error) => {
      handleAxiosErrors(error)
    })
}

export const axiosRequestCheckoutShippingMethods = () => {
  let { url, query } = config.checkkoutShippingMethods.readShippingMethods

  return axios
    .get(url, {
      params: {
        query,
      },
    })
    .catch((error) => {
      handleAxiosErrors(error)
    })
}

export const axiosRequestCart = (customerID) => {
  let { url, query } = config.checkout.cart
  //url = url.replace('{customerID}', customerID);

  return axios
    .get(url, {
      params: {
        query: query,
      },
    })
    .catch((error) => {
      handleAxiosErrors(error)
    })
}
export const requestDeliveryAddresses = () => {
  return (dispatch, getState) => {
    let state = getState()
    const customerID = state.user.user
    const selectedDeliveryAddress =
      state && typeof state.checkout.details.selectedDeliveryAddress != 'undefined'
        ? state.checkout.details.selectedDeliveryAddress
        : ''
    const defaultDeliveryAddressID = state.user.defaultDeliveryAddressID

    if (customerID) {
      dispatch(toggleCheckoutLoading('deliveryAddresses', true))

      return axiosRequestDeliveryAddresses({
        isSupplier: false,
      })
        .then((response) => {
          dispatch(toggleCheckoutLoading('deliveryAddresses', false))

          // Delivery Addresses
          const list = convertAvailableDeliveryAddressesToReact(response.data.data.readAddresss.edges)
          dispatch(updateDeliveryAddresses(list))

          // Refresh state
          state = getState()

          // Do extra if delivery address has been selected
          if (selectedDeliveryAddress) {
            const foundAddress = state.checkout.availableDeliveryAddresses.find((item) => {
              return typeof item.id != 'undefined' && typeof selectedDeliveryAddress != 'undefined'
                ? item.id == selectedDeliveryAddress
                : false
            })

            if (foundAddress) {
              //dispatch(updateSelectedAddress(selectedDeliveryAddress))
              dispatch(updateSelectedAddress(list[list.length - 1].id))
            }
          } else {
            dispatch(updateSelectedAddress(defaultDeliveryAddressID))
          }
        })
        .catch((error) => {
          dispatch(toggleCheckoutLoading('deliveryAddresses', false))
        })
    }
  }
}
export const processNewAddressForm = () => {
  return (dispatch, getState) => {
    const state = getState()
    const formData = buildNewAddressData(state.checkout.newAddressForm, state.user.user)

    let { url, query } = config.members.newAddress

    dispatch(toggleCheckoutLoading('newAddressForm', true))

    let customerID = 0
    if (window.placeOnBehalfOfID !== undefined && window.placeOnBehalfOfID > 0) {
      customerID = window.placeOnBehalfOfID
    }

    const isOrderOnBehalfOf = customerID ? true : false
    query = query.replace(/{PurchasingUser}/, isOrderOnBehalfOf)

    return axios
      .post(url, {
        query: query,
        variables: formData,
      })
      .then((response) => {
        const data = response.data
        dispatch(toggleCheckoutLoading('newAddressForm', false))

        dispatch(clearNewAddressForm())
        dispatch(requestDeliveryAddresses())
      })
      .catch((error) => {
        handleAxiosErrors(error)
        dispatch(toggleCheckoutLoading('newAddressForm', false))
      })
  }
}
export const requestDeliveryDates = () => {
  return (dispatch, getState) => {
    let state = getState()

    const customerID = typeof state.user.user != 'undefined' ? state.user.user : 0
    // const customerID = typeof(state.supplier.activeCustomer.id) != 'undefined' ? state.supplier.activeCustomer.id : 0;
    const selectedDeliveryDate =
      state && typeof state.checkout.details.selectedDeliveryDate != 'undefined'
        ? state.checkout.details.selectedDeliveryDate
        : ''
    // const postcode = state && typeof(state.checkout.details.selectedDeliveryAddressObj.postcode) != 'undefined' ? state.checkout.details.selectedDeliveryAddressObj.postcode : '';

    if (customerID) {
      let { url, query } = config.checkout.deliveryDates
      //query = query.replace('{memberid}', customerID);

      dispatch(toggleCheckoutLoading('deliveryDates', true))

      axios
        .get(url, {
          params: {
            query: query,
          },
          withCredentials: true,
        })
        .then((response) => {
          dispatch(toggleCheckoutLoading('deliveryDates', false))

          let deliveryDates = convertAvailableDeliveryDatesToReact(response.data.data)

          // If no delivery dates given, now we recreate a dummy one
          if (deliveryDates.length <= 0) {
            deliveryDates = createDummyAvailableDeliveryDates()
          }

          if (deliveryDates.length > 0) {
            dispatch(updateDeliveryDates(deliveryDates))

            // Update selected delivery date
            state = getState()

            const foundDeliveryDates = state.checkout.availableDeliveryDates.find((item) => {
              return item.date.toLowerCase() == selectedDeliveryDate.toLowerCase()
            })

            if (!foundDeliveryDates || !selectedDeliveryDate) {
              const recommendedDeliveryDate = state.checkout.availableDeliveryDates.find((item) => {
                return item.available
              })

              let selectedDeliveryDate = state.checkout.availableDeliveryDates[0].date
              if (recommendedDeliveryDate) {
                selectedDeliveryDate = recommendedDeliveryDate.date
              }

              const hasConsolidationDay = deliveryDates.find((x) => x?.consolidationDay === true)
              if (hasConsolidationDay) {
                dispatch(handleCheckoutCartFieldUpdate('hasConsolidationDay', true))
                selectedDeliveryDate = hasConsolidationDay?.date
              }

              // dispatch(updateSelectedDeliveryDate('selectedDeliveryDate', selectedDeliveryDate))
              dispatch(updateSelectedDeliveryDateCopy('selectedDeliveryDate', selectedDeliveryDate))
            }
          } else {
            dispatch(updateDeliveryDates(false))
            // dispatch(updateSelectedDeliveryDate('selectedDeliveryDate', ''))
            dispatch(updateSelectedDeliveryDateCopy('selectedDeliveryDate', ''))
          }
        })
        .catch((error) => {
          handleAxiosErrors(error)
          dispatch(toggleCheckoutLoading('deliveryDates', false))
        })
    }
  }
}

export const reCalculateCheckoutSurcharge = (date = null) => {
  return async (dispatch, getState) => {
    dispatch(toggleCheckoutLoading('summary', true))

    const { url, query } = config.checkout.updateCart

    const state = getState()
    const { details: checkoutDetails, readGlobalConfig } = state.checkout
    let { selectedCreditCard, selectedPaymentMethod, selectedDeliveryDate } = checkoutDetails
    const { enableCCAuthorization } = readGlobalConfig
    const cardID = getCardId(selectedPaymentMethod, selectedCreditCard)

    /* Finance fee re-calculation based on airwallex card authorization */
    let gateway = getPaymentGateway(selectedPaymentMethod)
    const selectedDate = moment(selectedDeliveryDate || date)
    const currentDate = moment(new Date())

    if (gateway == 'airwallex-card' && parseInt(selectedDate.diff(currentDate, 'days')) < 29 && enableCCAuthorization) {
      gateway = 'order-airwallex-card-authorization'
      selectedPaymentMethod = 'order-airwallex-card-authorization'
    }

    const formData = {
      PaymentMethod: selectedPaymentMethod,
      CardID: cardID,
    }

    try {
      const response = await axios.post(url, {
        query,
        variables: formData,
      })
      /**
       *  Mapping to checkout summary
       */
      const {
        SubTotal, // Your Products
        ShippingTotal, // Freight
        TaxTotal, //GST
        CreditCardSurcharge, //Finance Fee
        PointsEarned, // Redeemable Points
        StatusCredits, // Status Credits
        Total, // Total
        MinimumDeliveryFee,
        PaymentMethod,
        AppliedSurchargeTotal,
        AppliedSurcharges,
        PrepaidBalanceUsed,
      } = response?.data?.data?.updateCart
      dispatch(handleCheckoutCartFieldUpdate('subtotal', SubTotal))
      dispatch(handleCheckoutCartFieldUpdate('shippingCost', ShippingTotal))
      dispatch(handleCheckoutCartFieldUpdate('tax', TaxTotal))
      dispatch(handleCheckoutCartFieldUpdate('selectedCreditCardSurcharge', CreditCardSurcharge))
      dispatch(handleCheckoutCartFieldUpdate('pointsEarned', PointsEarned))
      dispatch(handleCheckoutCartFieldUpdate('statusCredits', StatusCredits))
      dispatch(handleCheckoutCartFieldUpdate('total', Total))
      dispatch(handleCheckoutCartFieldUpdate('paymentMethod', PaymentMethod))
      dispatch(handleCheckoutCartFieldUpdate('prepaidBalanceUsed', PrepaidBalanceUsed))
      dispatch(handleCheckoutCartFieldUpdate('minimumDeliveryFee', MinimumDeliveryFee))
      dispatch(toggleCheckoutLoading('summary', false))
      dispatch(
        replaceCheckoutCartDetails({
          appliedSurchargeTotal: AppliedSurchargeTotal,
          appliedSurcharges: AppliedSurcharges?.nodes,
        })
      )
    } catch (error) {
      handleAxiosErrors(error)
      dispatch(toggleCheckoutLoading('summary', false))
    }
  }
}

export const reUpdateDeliveryDate = (value) => {
  return async (dispatch, getState) => {
    dispatch(toggleCheckoutLoading('summary', true))

    const { url, query } = config.checkout.updateCart

    const state = getState()
    const checkoutDetails = state.checkout.details
    const { selectedCreditCard, selectedPaymentMethod, selectedDeliveryDate } = checkoutDetails

    const cardID = getCardId(selectedPaymentMethod, selectedCreditCard)

    const formData = {
      DeliveryDate: value,
    }

    try {
      const response = await axios.post(url, {
        query,
        variables: formData,
      })

      /**
       *  Mapping to checkout summary
       */
      const {
        SubTotal, // Your Products
        ShippingTotal, // Freight
        TaxTotal, //GST
        CreditCardSurcharge, //Finance Fee
        PointsEarned, // Redeemable Points
        StatusCredits, // Status Credits
        Total, // Total
        MinimumDeliveryFee,
        PrepaidBalanceUsed,
        ExtraAttribute1,
        PaymentMethod,
        AppliedSurchargeTotal,
        AppliedSurcharges,
      } = response?.data?.data?.updateCart

      dispatch(handleCheckoutCartFieldUpdate('subtotal', SubTotal))
      dispatch(handleCheckoutCartFieldUpdate('shippingCost', ShippingTotal))
      dispatch(handleCheckoutCartFieldUpdate('tax', TaxTotal))
      dispatch(handleCheckoutCartFieldUpdate('selectedCreditCardSurcharge', CreditCardSurcharge))
      dispatch(handleCheckoutCartFieldUpdate('pointsEarned', PointsEarned))
      dispatch(handleCheckoutCartFieldUpdate('statusCredits', StatusCredits))
      dispatch(handleCheckoutCartFieldUpdate('total', Total))
      dispatch(handleCheckoutCartFieldUpdate('minimumDeliveryFee', MinimumDeliveryFee))
      dispatch(handleCheckoutCartFieldUpdate('prepaidBalanceUsed', PrepaidBalanceUsed))
      dispatch(handleCheckoutCartFieldUpdate('ExtraAttribute1', ExtraAttribute1))
      dispatch(handleCheckoutCartFieldUpdate('paymentMethod', PaymentMethod))
      dispatch(
        replaceCheckoutCartDetails({
          appliedSurchargeTotal: AppliedSurchargeTotal,
          appliedSurcharges: AppliedSurcharges?.nodes,
        })
      )
      // updateSelectedDeliveryDate('selectedDeliveryDate', value)

      dispatch(toggleCheckoutLoading('summary', false))
      if (Total == 0) {
        dispatch(requestCart())
      }
    } catch (error) {
      handleAxiosErrors(error)
      dispatch(toggleCheckoutLoading('summary', false))
    }
  }
}

export const reUpdateShippingMethodPickup = (value) => {
  return async (dispatch, getState) => {
    dispatch(toggleCheckoutLoading('summary', true))

    const { url, query } = config.checkout.updateCart

    const state = getState()
    const checkoutDetails = state.checkout.details
    const { selectedCreditCard, selectedPaymentMethod, selectedDeliveryDate } = checkoutDetails

    const cardID = getCardId(selectedPaymentMethod, selectedCreditCard)

    const formData = {
      UrgentPickup: value,
    }

    try {
      const response = await axios.post(url, {
        query,
        variables: formData,
      })

      /**
       *  Mapping to checkout summary
       */
      const {
        SubTotal, // Your Products
        ShippingTotal, // Freight
        TaxTotal, //GST
        CreditCardSurcharge, //Finance Fee
        PointsEarned, // Redeemable Points
        StatusCredits, // Status Credits
        Total, // Total
        MinimumDeliveryFee,
        PrepaidBalanceUsed,
        ExtraAttribute1,
        PaymentMethod,
        ThreePLUrgentPickup,
      } = response?.data?.data?.updateCart

      dispatch(handleCheckoutCartFieldUpdate('subtotal', SubTotal))
      dispatch(handleCheckoutCartFieldUpdate('shippingCost', ShippingTotal))
      dispatch(handleCheckoutCartFieldUpdate('tax', TaxTotal))
      dispatch(handleCheckoutCartFieldUpdate('selectedCreditCardSurcharge', CreditCardSurcharge))
      dispatch(handleCheckoutCartFieldUpdate('pointsEarned', PointsEarned))
      dispatch(handleCheckoutCartFieldUpdate('statusCredits', StatusCredits))
      dispatch(handleCheckoutCartFieldUpdate('total', Total))
      dispatch(handleCheckoutCartFieldUpdate('minimumDeliveryFee', MinimumDeliveryFee))
      dispatch(handleCheckoutCartFieldUpdate('prepaidBalanceUsed', PrepaidBalanceUsed))
      dispatch(handleCheckoutCartFieldUpdate('ExtraAttribute1', ExtraAttribute1))
      dispatch(handleCheckoutCartFieldUpdate('paymentMethod', PaymentMethod))
      updateSelectedDeliveryDate('selectedDeliveryDate', value)

      dispatch(toggleCheckoutLoading('summary', false))
      if (Total == 0) {
        dispatch(requestCart())
      }
    } catch (error) {
      handleAxiosErrors(error)
      dispatch(toggleCheckoutLoading('summary', false))
    }
  }
}

export const updateShippingMethodToggle = (value) => {
  return async (dispatch, getState) => {
    const { url, query } = config.checkout.updateCartShipping

    const formData = {
      ShippingID: value,
    }

    try {
      const response = await axios.post(url, {
        query,
        variables: { Input: formData },
      })
      /**
       *  Mapping to checkout summary
       */
    } catch (error) {
      handleAxiosErrors(error)
    }
  }
}

export const reUpdateShippingMethod = (value) => {
  return async (dispatch, getState) => {
    dispatch(toggleCheckoutLoading('summary', true))

    const { url, query } = config.checkout.updateCart

    const state = getState()
    const checkoutDetails = state.checkout.details
    const { selectedCreditCard, selectedPaymentMethod, selectedDeliveryDate } = checkoutDetails

    const cardID = getCardId(selectedPaymentMethod, selectedCreditCard)

    const formData = {
      UrgentDelivery: value,
    }

    try {
      const response = await axios.post(url, {
        query,
        variables: formData,
      })

      /**
       *  Mapping to checkout summary
       */
      const {
        SubTotal, // Your Products
        ShippingTotal, // Freight
        TaxTotal, //GST
        CreditCardSurcharge, //Finance Fee
        PointsEarned, // Redeemable Points
        StatusCredits, // Status Credits
        Total, // Total
        MinimumDeliveryFee,
        PrepaidBalanceUsed,
        ExtraAttribute1,
        PaymentMethod,
      } = response?.data?.data?.updateCart

      dispatch(handleCheckoutCartFieldUpdate('subtotal', SubTotal))
      dispatch(handleCheckoutCartFieldUpdate('shippingCost', ShippingTotal))
      dispatch(handleCheckoutCartFieldUpdate('tax', TaxTotal))
      dispatch(handleCheckoutCartFieldUpdate('selectedCreditCardSurcharge', CreditCardSurcharge))
      dispatch(handleCheckoutCartFieldUpdate('pointsEarned', PointsEarned))
      dispatch(handleCheckoutCartFieldUpdate('statusCredits', StatusCredits))
      dispatch(handleCheckoutCartFieldUpdate('total', Total))
      dispatch(handleCheckoutCartFieldUpdate('minimumDeliveryFee', MinimumDeliveryFee))
      dispatch(handleCheckoutCartFieldUpdate('prepaidBalanceUsed', PrepaidBalanceUsed))
      dispatch(handleCheckoutCartFieldUpdate('ExtraAttribute1', ExtraAttribute1))
      dispatch(handleCheckoutCartFieldUpdate('paymentMethod', PaymentMethod))
      updateSelectedDeliveryDate('selectedDeliveryDate', value)

      dispatch(toggleCheckoutLoading('summary', false))
      if (Total == 0) {
        dispatch(requestCart())
      }
    } catch (error) {
      handleAxiosErrors(error)
      dispatch(toggleCheckoutLoading('summary', false))
    }
  }
}

export const processPayment = () => {
  return (dispatch, getState) => {
    const state = getState()
    const formData = buildCheckoutData(state.checkout)
    console.log(formData)
    const cartItems = state.checkout.cart.list
    const cartId = state.checkout.cart.id
    const cart = state.checkout.cart

    const selectedPaymentMethod = state.checkout.details.selectedPaymentMethod
    segmentTrackPaymentInfoEntered(cartId, selectedPaymentMethod, null)

    segmentTrackCheckoutStepCompleted(cart, selectedPaymentMethod, null)

    dispatch(toggleCheckoutLoading('summary', true))

    //update cart first
    axios
      .post(config.checkout.updateCart.url, {
        query: config.checkout.updateCart.query,
        variables: formData,
      })
      .then((response) => {
        //then make the payment
        return axios.post(config.checkout.processPayment.url, {
          query: config.checkout.processPayment.query,
          variables: formData,
        })
      })
      .then((response) => {
        const order = response.data.data.payForOrder
        dispatch(clearCheckoutCart())
        dispatch(updateActiveCustomerName({}))
        dispatch(updateActive3PLCustomerName({}))
        dispatch(resetActiveCustomer())
        /** If Payment Method is a redirect method, dont call Segment Tracking here */
        if (!order?.PaymentRedirectURL) {
          segmentTrackOrderCompleted(cartItems, cartId, cart)
        } else {
          LS.set('pendingSegmentOrderPayload', {
            cartItems: cartItems,
            cartId: cartId,
            cart: cart,
          })
        }

        if (order?.PaymentRedirectURL) {
          window.location.href = order?.PaymentRedirectURL
        } else {
          window.location.href = `/checkout/confirmation/${order.ID}`
        }
      })
      .catch((error) => {
        if (error?.message === 'Quantity requested greater than Maximum Allocated Value') {
          window.location.reload()
        }
        segmentTrackOrderCompleted(cartItems, cartId, cart)
        LS.set('paidOrderId', cartId)
        if (error?.message === 'Order has already been paid.') {
          const paidOrderId = LS.get('paidOrderId')
          dispatch(clearCheckoutCart())
          dispatch(resetActiveCustomer())
          window.location.href = `/checkout/confirmation/${paidOrderId}`
        }
        if (error?.message !== 'Quantity requested greater than Maximum Allocated Value') {
          handleAxiosErrors(error)
        }
        dispatch(toggleCheckoutLoading('summary', false))
      })
  }
}

// TODO
export const processPaymentWithoutSaving = () => {
  return (dispatch, getState) => {
    const state = getState()
    const formData = buildCheckoutData(state.checkout)
    const {
      customerName: CardName,
      cardName: CardReference,
      cardExpiryMonth,
      cardExpiryYear,
    } = state.checkout.newCreditCardForm

    delete formData?.CardID

    dispatch(toggleCheckoutLoading('summary', true))

    const tokenizeData = {
      card_holder: CardName,
      month: parseInt(cardExpiryMonth, 10),
      year: parseInt(cardExpiryYear, 10),
    }

    tillPayment.tokenize(
      tokenizeData,
      (token, cardData) => {
        const { card_type, last_four_digits } = cardData

        const variables = {
          ...formData,
          SaveCard: false,
          Card: {
            Number: last_four_digits,
            ExpiryMonth: parseInt(cardExpiryMonth, 10),
            ExpiryYear: parseInt(cardExpiryYear, 10),
            Token: token,
            CardName,
            CardReference,
            CardIssuer: card_type,
          },
        }

        axios
          .post(config.checkout.updateCart.url, {
            query: config.checkout.updateCart.query,
            variables: formData,
          })
          .then((response) => {
            return axios.post(config.checkout.processPayment.url, {
              query: config.checkout.processPayment.query,
              variables,
            })
          })
          .then((response) => {
            dispatch(updateActiveCustomerName({}))
            dispatch(updateActive3PLCustomerName({}))
            dispatch(resetActiveCustomer())
            const order = response.data.data.payForOrder
            window.location.href = `/checkout/confirmation/${order.ID}`
          })
          .catch((error) => {
            handleAxiosErrors(error)
            dispatch(toggleCheckoutLoading('summary', false))
          })
      },
      (errors) => {
        dispatch(toggleCheckoutLoading('summary', false))
        return handleAxiosErrors(error)
      }
    )
  }
}

export const clearNewAddressForm = () => {
  return {
    type: 'CLEAR_NEW_ADDRESS_FORM',
  }
}
export const clearNewCreditCardForm = () => {
  return {
    type: 'CLEAR_NEW_CREDIT_CARD_FORM',
  }
}
export const clearCheckoutCart = () => {
  return {
    type: 'CLEAR_CHECKOUT_CART',
  }
}
export const validateCheckout = (checkoutData, memberType) => {
  const { details, cart } = checkoutData
  const {
    selectedPaymentMethod,
    selectedDeliveryDate,
    selectedDeliveryAddress,
    selectedCreditCard,
    reference,
    pickupEmptyKegs,
    kegsToPickup,
  } = details

  if (selectedPaymentMethod == '' || selectedDeliveryDate == '' || selectedDeliveryAddress == '') {
    return false
  }

  if (!reference) {
    return false
  }

  if (pickupEmptyKegs && (!kegsToPickup || kegsToPickup == 0)) {
    return false
  }

  if (window?.isSubWholesaler) {
    return true
  }

  if (cart.list.length <= 0) {
    return false
  }

  // extra check based on member type
  if (typeof memberType != 'undefined') {
    if (memberType === 'wholesaler') {
      if (cart.total <= 0) {
        return false
      }
    }
  }

  // extra check based on payment type
  if (
    typeof selectedPaymentMethod != 'undefined' &&
    selectedPaymentMethod == 'order-airwallex-card' &&
    (selectedCreditCard == '' || selectedCreditCard == null)
  ) {
    return false
  }

  return true
}

export const handleCheckoutGoogleAddressChecker = (address) => {
  return (dispatch, getState) => {
    // if (address !== null && address.address_components) {
    const streetNumber = getAddressComponent('street_number', address?.address_components || '')
    const streetName = getAddressComponent('route', address?.address_components || '')
    const postalCode = getAddressComponent('postal_code', address?.address_components || '')
    const suburb = getAddressComponent('locality', address.address_components || '')
    dispatch(handleNewAddressFieldUpdate('streetNumber', streetNumber))
    dispatch(handleNewAddressFieldUpdate('streetName', streetName))
    dispatch(handleNewAddressFieldUpdate('postcode', postalCode))
    dispatch(handleNewAddressFieldUpdate('suburb', suburb))
    // }
  }
}

export const handleSegmentOrderCompleteForRedirect = () => {
  const { cartItems, cartId, cart } = LS.get('pendingSegmentOrderPayload')

  if (
    cartId &&
    (cart?.paymentMethod == 'order-tillpayments-zippay' || cart?.paymentMethod == 'order-tillpayments-polipay')
  ) {
    segmentTrackOrderCompleted(cartItems, cartId, cart)
    LS.remove('pendingSegmentOrderPayload')
  }
}

/* Coupons implementation for for wholesaler checkout */
export const axiosApplyCoupon = (code) => {
  return async (dispatch, getState) => {
    let { url, query } = config.checkout.applyCoupon

    dispatch(toggleCheckoutLoading('couponLoading', true))

    return axios
      .post(url, {
        query,
        variables: { Code: code },
      })
      .then(async () => {
        //Disable coupon field once coupon is applied
        dispatch(handleFieldUpdate('isCouponApplied', true))
        dispatch(handleFieldUpdate('isCouponValid', true))
        dispatch(toggleCheckoutLoading('couponLoading', false))

        //Request cart after adding coupon from checkout summary
        await dispatch(requestCartCoupons())

        //Show apply coupon alert
        createAlert({ message: 'Coupon Applied' }, 'success')
      })
      .catch((error) => {
        dispatch(handleFieldUpdate('isCouponValid', false))
        dispatch(toggleCheckoutLoading('couponLoading', false))
        handleAxiosErrors(error)
      })
  }
}

export const axiosRemoveCoupon = (code) => {
  return async (dispatch, getState) => {
    let { url, query } = config.checkout.removeAppliedCoupon

    dispatch(toggleCheckoutLoading('couponLoading', true))

    return axios
      .post(url, {
        query,
      })
      .then(async () => {
        //Remove active coupon from checkout summary
        dispatch(toggleCheckoutLoading('couponLoading', false))
        dispatch(replaceCheckoutCartDetails({ appliedDiscountCoupons: [] }))
        dispatch(handleFieldUpdate('couponCode', ''))
        dispatch(handleFieldUpdate('isCouponApplied', false))
        dispatch(handleFieldUpdate('isCouponValid', true))

        //Request cart after coupon removel from checkout summary
        await dispatch(requestCartCoupons())

        //Show remove coupon alert
        createAlert({ message: 'Coupon Removed' }, 'success')
      })
      .catch((error) => {
        dispatch(toggleCheckoutLoading('couponLoading', false))
        handleAxiosErrors(error)
      })
  }
}

export const requestCartCoupons = () => {
  return async (dispatch, getState) => {
    const state = getState()
    const customerID = typeof state.user.user != 'undefined' ? state.user.user : 0

    if (customerID) {
      dispatch(toggleCheckoutLoading('cart', true))

      return axiosRequestCart(customerID)
        .then((response) => {
          dispatch(reCalculateCheckoutSurcharge())
          const cart = response.data.data.readOneCart

          dispatch(toggleCheckoutLoading('cart', false))

          // Cart
          const list = convertCartToReact(cart, state.user)
          dispatch(updateCart(list))

          dispatch(
            setUserCredentials({
              calculatedCurrentLoyaltyPoints: getCurrentLoyaltyPointsCheckout(list),
            })
          )

          // Checkout Detail
          const details = convertCheckoutDetailsToReact(cart)

          //Store applied coupons
          if (details?.appliedDiscountCoupons?.[0]?.InternalItemID) {
            dispatch(handleFieldUpdate('couponCode', details?.appliedDiscountCoupons?.[0]?.InternalItemID))
            dispatch(handleFieldUpdate('isCouponApplied', true))
            dispatch(handleFieldUpdate('isCouponValid', true))
          }

          details.memberid = customerID
          dispatch(replaceCheckoutCartDetails(details))

          const cartId = cart?.ID

          segmentTrackCheckoutStarted(list, cartId, details)

          let updatedState = getState()
          const selectedPaymentMethod = updatedState.checkout.details.selectedPaymentMethod

          segmentTrackCheckoutStepViewed(cartId, selectedPaymentMethod, null)
        })
        .catch((error) => {
          dispatch(toggleCheckoutLoading('cart', false))
        })
    }
  }
}
